// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"162":"8478d5629633b82afcd4","821":"f90280808991358d8fc5"}[chunkId] + ".chunk.js";
};